module.exports = __webpack_public_path__ + "static/media/greenhouse3-08.57aab50f.webp";